module.exports = __webpack_public_path__ + "img/2010 winteressen 004.4b286400.jpg";